// extracted by mini-css-extract-plugin
export var auto = "_3b-1";
export var spinner = "_3b-0";